import { MatIconRegistry } from '@angular/material/icon';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';
import { PipesModule } from './pipes/pipes.module';
import { SettingsModule } from './settings/settings.module';
import { TopicsModule } from './topics/topics.module';
import { ThinSignupCompleteComponent } from './ui/thinSignupComplete.component';
import { ThinSignupStartComponent } from './ui/thinSignupStart.component';
import { ReaderComponent } from './digestReader/reader.component';
import { EmptyPane } from './digestReader/emptyPane.component';
import { TopicMenuButtonComponent } from './digestReader/topicMenuButton';
import { DefaultRouter } from './digestReader/defaultRouter.component';
import { TopicFollowersDetails } from './digestReader/topicFollowersDetails.component';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { MaterialModule } from '../material.module';
import { MomentModule } from 'ngx-moment';
import { FlexLayoutModule } from "@angular/flex-layout";
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { App, routes } from './';
import * as ui from './ui';
import { DigestSchedulerComponent } from './digestSchedule';
import { ThinSignupComponent } from './ui/thinSignup.component';
import { GeneralModule } from './general/general.module';
import { NameTopicDialogComponent } from './digestReader/nameTopicDialog.component';
import { DirectivesModule } from './directives/directives.module';
import { LoginModule } from './login/login.module';
import { NavigationModule } from './navigation/navigation.module';
import { BrowseModule } from './browse/browse.module';
import { SummaryModule } from './summary/summary.module';
import { BriefingsModule } from './briefings/briefings.module';
import { ReadingModule } from './reading/reading.module';
import { HomeModule } from './home/home.module';
import { PartnerModule } from './partner/partner.module';
import { GroupsModule } from './groups/groups.module';
import { UsersModule } from './users/users.module';
import { environment } from './environments/environment';
import { TenantService } from './services/tenant.service';
import { AccountModule } from './account/account.module';
import { RoutingHistoryService } from './services/routingHistory.service';
import { TagsModule } from './tags/tags.module';
import { ErrorsInterceptor } from './interceptors/errors.interceptor';
import { VersionChekerInterceptor } from './interceptors/versionChecker.interceptor';
import { SearchRouteComponent } from './digestReader/searchRoute.component';
import { AuthenticateComponent } from './ui/authenticate.component';

@NgModule({
    declarations: [
        App,
        ReaderComponent,
        SearchRouteComponent,
        EmptyPane,
        TopicFollowersDetails,
        ui.LogoHeaderComponent,
        ui.RegisterComponent,
        AuthenticateComponent,
        ThinSignupComponent,
        ThinSignupStartComponent,
        ThinSignupCompleteComponent,
        TopicMenuButtonComponent,
        NameTopicDialogComponent,
        DigestSchedulerComponent,
        ui.StartSignupComponent,
        DefaultRouter,
    ],
    imports: [
        AccountModule,
        BrowserAnimationsModule,
        BrowserModule,
        BriefingsModule,
        DirectivesModule,
        FlexLayoutModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        LoginModule,
        MaterialModule,
        MomentModule,
        NavigationModule,
        InfiniteScrollModule,
        routes,
        PartnerModule,
        PipesModule,
        BrowseModule,
        GeneralModule,
        GroupsModule,
        SettingsModule,
        HomeModule,
        ReadingModule,
        TopicsModule,
        SummaryModule,
        TagsModule,
        UsersModule
    ],
    providers: [
        {provide: HTTP_INTERCEPTORS, useClass: ErrorsInterceptor, multi: true },
        {provide: HTTP_INTERCEPTORS, useClass: VersionChekerInterceptor, multi: true },
        {provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: { verticalPosition: 'top' }}
    ],
    entryComponents: [
        ui.StartSignupComponent,
        NameTopicDialogComponent,
        TopicFollowersDetails,
    ],
    bootstrap: [App]
})
export class AppModule {
    constructor(iconRegistry: MatIconRegistry, routingHistoryService: RoutingHistoryService, private tenantService: TenantService) {
        routingHistoryService.loadRouting();
        if (!window.location.href.includes('helpoff=true')) {
            this.tenantService.getUnauthTenantInfo()
            .subscribe(tenant => {
                if(tenant.settings.blockIntercom !== 'true'){
                    this.addIntercom();
                }
            });
        }
        iconRegistry.registerFontClassAlias('fontawesome', 'fa');
        this.addStripe();
    }

    addIntercom() {
        window['intercomSettings'] = { app_id: environment.intercomAppId };
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.innerText = `
            (function(){var w=window;var ic=w.Intercom;if(typeof ic==="function"){ic('reattach_activator');ic('update',intercomSettings);}else{var d=document;var i=function(){i.c(arguments)};i.q=[];i.c=function(args){i.q.push(args)};w.Intercom=i;function l(){var s=d.createElement('script');s.type='text/javascript';s.async=true;
            s.src='https://widget.intercom.io/widget/${environment.intercomAppId}';
            var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s,x);}if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})()
        `;
        document.getElementsByTagName('head')[0].appendChild(script);
    }

    addStripe() {
        if (environment.stripePublishableKey) {
            const stripe = window['Stripe'](environment.stripePublishableKey)
            window['stripe'] = stripe;
            window['elements'] = stripe.elements();
        }
    }
}
